import strappedConnected from "modules/Core/higher-order-components/strappedConnected";
import component from "../BoothScreen/component";
import cells from "modules/booths/state/index";
import { useEffect, useMemo } from "react";
import Card from "modules/Core/sub-modules/ui-kit/components/Card";
import Screen from "modules/Core/sub-modules/ui-kit/components/Screen";
import styles from "./styles.module.scss";
import Loader from "modules/Core/sub-modules/ui-kit/components/Loader";
import { useNavigate } from "react-router-dom";

const withPlaceholder = (Component, PlaceholderComponent, isEmptyKey = "shouldDisplayPlaceholder") => (props) => {
    const C = useMemo(() => Boolean(props[isEmptyKey]) ? PlaceholderComponent : Component, [PlaceholderComponent, Component, props?.[isEmptyKey]]);
    return <C {...props} />
}

const Placeholder = ({ isLoading }) => {
    return (
        <Screen flex center hideHeader={true}>
            <Loader overlay loading={isLoading}>
                <Card className={styles.placeholder} header="No Focused Booth Found" fitContent  >
                    No focused booths found, return to booths feed to see available booths.
                </Card>
            </Loader>
        </Screen>
    )
}

export default strappedConnected(
    component,
    {
        focusedBoothId: cells.fetchFocusedBooth.selectors.id,
        isLoading: cells.fetchFocusedBooth.selectors.isLoading,
        hasNoFocusedBooths: cells.fetchFocusedBooth.selectors.hasNoFocusedBooths

    },
    { fetch: cells.fetchFocusedBooth.action },
    ({  focusedBoothId, isLoading, hasNoFocusedBooths }) => {
        const navigate = useNavigate();
        useEffect(() => {
            if(hasNoFocusedBooths) {
                navigate("/booths")
            }
        }, [hasNoFocusedBooths])
        return {
            // shouldDisplayPlaceholder: !focusedBoothId && !isLoading
        }
    }
);